module.exports = __webpack_public_path__ + "fcd65c29a84eff16cb192eb05e5dc2d2.jpg";